import { useState, useEffect } from "react";

export const useEducationBarProminent = (): { isPageTop: boolean } => {
    const [isPageTop, setIsPageTop] = useState(true);

    useEffect(() => {
        const container = document.querySelector(".sw-layout-scrollable-element");
        const handleScroll = () => {
            const educationBar = document.getElementById("educationBarProminent");
            if (container?.scrollTop > educationBar?.offsetHeight + 30) {
                setIsPageTop(false);
            } else {
                setIsPageTop(true);
            }
        };
        container?.addEventListener("scroll", handleScroll);
        return () => container?.removeEventListener("scroll", handleScroll);
    }, []);

    return { isPageTop };
};
